import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import "../HomeScreen.css";
import "./Hotels.css";
import Navbar from "../Navbar";
import Footer from "../Footer";

const Flights = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    departureCity: "",
    arrivalCity: "",
    departureDate: "",
    returnDate: "",
    passengers: "1",
    travelClass: "Economy",
    requirements: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await addDoc(collection(db, "enquiry"), {
        ...form,
        enquiryType: "flight booking",
        createdAt: serverTimestamp(),
      });
      setStatus("success");
      setForm({
        name: "", email: "", phone: "", departureCity: "", arrivalCity: "",
        departureDate: "", returnDate: "", passengers: "1", travelClass: "Economy", requirements: "",
      });
      setTimeout(() => setStatus(null), 4000);
    } catch (err) {
      console.error("Error submitting flight enquiry: ", err);
      setStatus("error");
    }
  };

  // Airline Partners with Real Logos (using AirLabs CDN)
  const airlinePartners = [
    { name: "IndiGo", iata: "6E", logo: "https://airlabs.co/img/airline/m/6E.png" },
    { name: "Akasa Air", iata: "QP", logo: "https://play-lh.googleusercontent.com/1DqjyvkBti8dwUo32ocRA3Nv6-eQaEdIKnIVjcwgk0fzVYgdrRXDE64RlGrakV8czCl5SArcR7t8Nkbtk51j=w240-h480-rw" },
    { name: "Air India", iata: "AI", logo: "https://airlabs.co/img/airline/m/AI.png" },
    { name: "AirAsia", iata: "AK", logo: "https://airlabs.co/img/airline/m/AK.png" },
    { name: "Qatar Airways", iata: "QR", logo: "https://airlabs.co/img/airline/m/QR.png" },
    { name: "Emirates", iata: "EK", logo: "https://airlabs.co/img/airline/m/EK.png" },
    { name: "Singapore Airlines", iata: "SQ", logo: "https://airlabs.co/img/airline/m/SQ.png" },
    { name: "Malaysia Airlines", iata: "MH", logo: "https://airlabs.co/img/airline/m/MH.png" },
    { name: "VietJet Air", iata: "VJ", logo: "https://airlabs.co/img/airline/m/VJ.png" },
    { name: "SriLankan Airlines", iata: "UL", logo: "https://airlabs.co/img/airline/m/UL.png" },
    { name: "British Airways", iata: "BA", logo: "https://airlabs.co/img/airline/m/BA.png" },
    { name: "Lufthansa", iata: "LH", logo: "https://airlabs.co/img/airline/m/LH.png" },
    { name: "Etihad Airways", iata: "EY", logo: "https://airlabs.co/img/airline/m/EY.png" },
    { name: "Turkish Airlines", iata: "TK", logo: "https://airlabs.co/img/airline/m/TK.png" },
    { name: "Air France", iata: "AF", logo: "https://airlabs.co/img/airline/m/AF.png" },
    { name: "KLM Royal Dutch", iata: "KL", logo: "https://airlabs.co/img/airline/m/KL.png" },
    { name: "Swiss International", iata: "LX", logo: "https://airlabs.co/img/airline/m/LX.png" },
    { name: "Thai Airways", iata: "TG", logo: "https://airlabs.co/img/airline/m/TG.png" },
  ];

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section with Background Image */}
      <section
        className="hero-section"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="hero-overlay">
          <h1>
            Book Your Next ✈️ <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> Flight </span>
          </h1>
          <p>Get the best domestic and international flight deals with expert assistance.</p>
        </div>
      </section>

      {/* Airline Partners Section - Using Hotels.css styles */}
      <section className="hotel-partners-section">
        <div className="section-container">
          <h2 className="section-title-main">Fly with Leading Airlines Worldwide</h2>
          <p className="section-subtitle">We partner with the world's most trusted airlines to bring you the best connectivity and comfort.</p>
          <div className="partners-grid">
            {airlinePartners.map((airline, idx) => (
              <div className="partner-card" key={idx}>
                <div className="partner-logo">
                  <img
                    src={airline.logo}
                    alt={`${airline.name} logo`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "8px"
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext y='.9em' font-size='90'%3E✈️%3C/text%3E%3C/svg%3E";
                    }}
                  />
                </div>
                <h4>{airline.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hotels-enquiry-section">
        <div className="hotels-enquiry-container">

          {/* Left Side: Info */}
          <div className="hotels-info-panel">
            <h2>Why book with us?</h2>
            <ul className="hotels-benefits">
              <li>
                <span className="benefit-icon">💰</span>
                <div>
                  <strong>Get Best Deals on flight Tickets with zero Service Charges.</strong>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🎯</span>
                <div>
                  <strong>5-10% off on Domestic & International Flights.</strong>
                </div>
              </li>
              <li>
                <span className="benefit-icon">📱</span>
                <div>
                  <strong>Get your boarding pass on your whatsapp before 24 hrs.</strong>
                </div>
              </li>
              <li>
                <span className="benefit-icon">💳</span>
                <div>
                  <strong>Minimum Cancelation Charges & lower Date change fess</strong>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🎧</span>
                <div>
                  <strong>Seamless Experience & 24 hrs helpline Support with our experts</strong>
                </div>
              </li>
            </ul>

            <div className="hotels-contact-direct">
              <p>Need instant help? Call us directly:</p>
              <a href="tel:+919096785868" className="direct-phone">📞 +91 9096785868</a>
            </div>
          </div>

          {/* Right Side: Enquiry Form */}
          <div className="hotels-form-panel">
            <h3>Flight Enquiry Form</h3>
            <p className="form-subtitle">Fill in your travel details and our team will share the best flight options within 2 hours.</p>

            <form className="hotels-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label>Full Name *</label>
                  <input type="text" name="name" placeholder="John Doe" value={form.name} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-field">
                <label>Email Address</label>
                <input type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} />
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Departure City (From) *</label>
                  <input type="text" name="departureCity" placeholder="e.g., Delhi, Mumbai" value={form.departureCity} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Arrival City (To) *</label>
                  <input type="text" name="arrivalCity" placeholder="e.g., Dubai, London" value={form.arrivalCity} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Departure Date *</label>
                  <input type="date" name="departureDate" value={form.departureDate} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Return Date (Optional)</label>
                  <input type="date" name="returnDate" value={form.returnDate} onChange={handleChange} />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Number of Passengers *</label>
                  <select name="passengers" value={form.passengers} onChange={handleChange} required>
                    <option value="1">1 Passenger</option>
                    <option value="2">2 Passengers</option>
                    <option value="3">3 Passengers</option>
                    <option value="4">4 Passengers</option>
                    <option value="5+">5+ (Group)</option>
                  </select>
                </div>
                <div className="form-field">
                  <label>Travel Class *</label>
                  <select name="travelClass" value={form.travelClass} onChange={handleChange} required>
                    <option value="Economy">Economy</option>
                    <option value="Premium Economy">Premium Economy</option>
                    <option value="Business">Business</option>
                    <option value="First Class">First Class</option>
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label>Special Requirements (Optional)</label>
                <textarea name="requirements" rows="4" placeholder="e.g., Prefer morning flights, extra baggage, specific airline, infant traveling, etc." value={form.requirements} onChange={handleChange}></textarea>
              </div>

              {status === "success" && (
                <div className="form-status success">
                  ✅ Enquiry sent successfully! Our team will contact you shortly with the best flight options.
                </div>
              )}
              {status === "error" && (
                <div className="form-status error">
                  ⚠️ Something went wrong. Please try again or WhatsApp us directly.
                </div>
              )}

              <button type="submit" className="submit-enquiry-btn" disabled={status === "sending"}>
                {status === "sending" ? <span className="btn-spinner"></span> : "Submit Flight Enquiry"}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Flights;